import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import { beforeEnterCheckPermission } from './utils/routePermissions';

export default [
  {
    name: 'dynamic-content',
    path: '/dynamicContent',
    component: () => import('@/views/dynamicContent/DynamicContent.vue'),
    meta: {
      title: 'المحتوى المتغير',
    },
    beforeEnter(to, from, next) {
      const { has, redirectTo } = beforeEnterCheckPermission(
        appPermissions.dynamicContent,
      );
      if (has) return next();
      else return next(redirectTo);
    },
  },
];
